import { render, staticRenderFns } from "./ModifySecondaryPassword.vue?vue&type=template&id=45ce6a63&scoped=true"
import script from "./ModifySecondaryPassword.vue?vue&type=script&lang=js"
export * from "./ModifySecondaryPassword.vue?vue&type=script&lang=js"
import style0 from "./ModifySecondaryPassword.vue?vue&type=style&index=0&id=45ce6a63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce6a63",
  null
  
)

export default component.exports